import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: 'cs-tile-footer',
    imports: [],
    templateUrl: './tile-footer.component.html',
    styleUrl: './tile-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TileFooterComponent {
    categoryNametext = input('');
    gameNametext = input('');
    gameTypeText = input('');
    inlineStyleCategoryName = input('');
    inlineStyleGameName = input('');
    inlineStyleGameType = input('');
    isLegacy = input(false);
    customCategoryContainerClass = input('');
    customCategoryNameClass = input('');
    customGameNameClass = input('');
    customGameTypeClass = input('');
}
